module.exports = require("./lib/randomstring");